import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { BaseComponent } from '@library-shared/base/base.component';
import { spRole_List_UserEdit } from '@models/StoredProcs/spRole_List_UserEdit';

import { DxDataGridComponent, DxDataGridModule } from 'devextreme-angular';
import { DisplayMode } from '@constant/display-mode.constant';
import { vUserX } from '@models/Views-Extended/vUserX.extended';
import { UserService } from '@services/user/user.service';
import { DxiColumnModule, DxoEditingModule } from 'devextreme-angular/ui/nested';

@Component({
    selector: 'app-user-role-select',
    templateUrl: './user-role-select.component.html',
    styleUrls: ['./user-role-select.component.scss'],
    imports: [DxiColumnModule, DxoEditingModule, DxDataGridModule]
})
export class UserRoleSelectComponent extends BaseComponent implements OnInit {
    _user: vUserX = new vUserX();
    @Input()
    set user(value: vUserX) {
        this._user = value;
        this.loadData();
    }
    get user(): vUserX {
        return this._user;
    }

    @Input() displayMode = DisplayMode.DisplayMode;

    @ViewChild('grid', { static: true }) grid: DxDataGridComponent;

    get editMode() {
        return this.displayMode === DisplayMode.EditMode;
    }

    dataSource: spRole_List_UserEdit[] = [];

    constructor(private userService: UserService) {
        super();
    }

    ngOnInit() {}

    onToolbarPreparing(e: any) {
        e.toolbarOptions.visible = false;
    }

    loadData() {
        if (this.user && this.user.user_id) {
            this.isLoading = true;
            this.userService.Role_List_UserEdit(this.user.user_id).subscribe((data) => {
                this.dataSource = data.records;
                this.isLoading = false;
            });
        } else {
            this.dataSource = [];
        }
    }

    save(): spRole_List_UserEdit[] {
        this.grid.instance.saveEditData();
        return this.dataSource;
    }

    cancel() {
        this.grid.instance.cancelEditData();
    }
}
